
  import { Vue, Component, Prop } from 'vue-property-decorator';
  import { Field, DropdownField } from '@samc/centricity-core';
  import { PackageTypeSource } from '@/Sources';

  @Component({
    name: 'package-type-dropdown-field',
    components: { Field, DropdownField }
  })
  export default class PackageTypeDropdownField extends Vue {
    @Prop() public value!: string;
    @Prop({ default: 'Package Type' }) public label!: string;
    @Prop({ type: Boolean, default: false }) public disabled!: boolean;
    @Prop({ type: Boolean, default: false }) public autoAssign!: boolean;
    @Prop() public placeholder!: string;

    public source: PackageTypeSource = new PackageTypeSource();

    public get val(): string { return this.value; }
    public set val(value: string) {
      this.$emit('input', value);
    }
  }
